import { render, staticRenderFns } from "./editAvatar.vue?vue&type=template&id=18658bc3&scoped=true&"
import script from "./editAvatar.vue?vue&type=script&lang=js&"
export * from "./editAvatar.vue?vue&type=script&lang=js&"
import style0 from "./editAvatar.vue?vue&type=style&index=0&id=18658bc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18658bc3",
  null
  
)

export default component.exports